import {extractModuleIdentifiers, ModuleNode} from '@backstage-components/base';
import type {FC} from 'react';
import {PublicAccessCodeComponent} from './PublicAccessCodeComponent';
import {SchemaType} from './PublicAccessCodeDefinition';

export type PublicAccessCodeProps = SchemaType;

export const PublicAccessCodePreviewComponent: FC<
  ModuleNode<'PublicAccessCode', PublicAccessCodeProps>
> = (definition) => {
  const {component, config, props} = definition.module;
  return (
    <PublicAccessCodeComponent
      component={component}
      config={config}
      {...extractModuleIdentifiers(definition.module)}
      props={props}
    />
  );
};
